var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"vm-pre-box",class:{pointer: !_vm.is_open && _vm.is_overflow},domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }